export enum ETicketNameStatuses {
    PENDING = 'pending',
    SUCCESS = 'success',
    ERROR = 'error'
}
